import { css, keyframes } from 'styled-components';

const shake = keyframes`
  0% { transform: translateX(0) }
  25% { transform: translateX(8px) }
  50% { transform: translateX(-8px) }
  75% { transform: translateX(8px) }
  100% { transform: translateX(0) }
`;

export const shakingAnimationMixin = css`
  animation: ${shake} 0.3s ease-in 1;
`;
